import Item from './Item';
import Backpack from './Backpack';
import Stack from './Stack';
import StickWithFood from './StickWithFood';
import Container from './Container';
import Flashlight from './Flashlight';
import Leaf from './Leaf';
import Ball from './Ball';
import Bucket from './Bucket';
import Book from './Book';
import TentRolled from './TentRolled';

export default class ItemsFactory {
  constructor(game, location, itemsByID) {
    this.game = game;
    this.location = location;
    this.itemsByID = itemsByID;
  }

  getItem(id) {
    const data = { ...this.itemsByID[id], id };
    let item;
    switch (id) {
      case 'backpack_ari':
      case 'backpack_elinor':
      case 'backpack_olive':
        item = new Backpack({ game: this.game, location: this.location, data });
        break;

      case 'marshmallow_stick':
      case 'banana_stick':
      case 'pickle_stick':
      case 'apple_stick':
      case 'banana_peanut_stick':
        item = new StickWithFood({ game: this.game, location: this.location, data });
        break;

      case 'stack':
        item = new Stack({ game: this.game, location: this.location, data });
        break;

      case 'flashlight':
        item = new Flashlight({ game: this.game, location: this.location, data });
        break;

      case 'picnic_basket':
      case 'coolbox':
        item = new Container({ game: this.game, location: this.location, data });
        break;

      case 'leaf':
        item = new Leaf({ game: this.game, location: this.location, data });
        break;

      case 'ball':
        item = new Ball({ game: this.game, location: this.location, data });
        break;

      case 'bucket':
        item = new Bucket({ game: this.game, location: this.location, data });
        break;

      case 'book_1':
      case 'book_2':
      case 'book_3':
        item = new Book({ game: this.game, location: this.location, data });
        break;

      case 'tent_1_rolled':
      case 'tent_2_rolled':
      case 'tent_3_rolled':
        item = new TentRolled({ game: this.game, location: this.location, data });
        break;

      default:
        item = new Item({ game: this.game, location: this.location, data });
        break;
    }

    return item;
  }
}
